import React, { PropTypes } from 'react';
import ReactSelect from './ReactSelect';

export function age (props) {
  const { 
    options, 
    value, 
    onChange, 
    required,
  } = props;

  return (
    <Age
      required={required}
      value={value}
      onChange={onChange}
      {...options}
    />
  );
}

class Age extends React.Component {
  constructor(props) {
    super(props);

    this.ageOptions = Array.from(Array(120), (_, age) => {
      const label = age <= 1 ? __('{age} year old', 'appwrapper', { age }) : __('{age} years old', 'appwrapper', { age }) 

      return {
        label,
        value: age,
      }
    });
  }

  render() {

    const {
      value,
      onChange,
    } = this.props;



    return (
      <div className='select-age-wrapper form-input'>
        <ReactSelect 
          value={value}
          onChange={onChange}
          options={this.ageOptions}
        />
      </div>
    );
  }
}

export default Age;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Age.js